

























































































































import Vue from 'vue';
import Redactor from '../../../components/Redactor.vue'
import Checkbox from '../../../components/Checkbox.vue'
import SettingsService from '../../settings.service'
import DropdownStore from './DropdownStore.vue'
import HotVar from './HotVar.vue'

const settingsService = new SettingsService()

export default Vue.extend({
    props: ['settings'],
    data() {
        return {
            domains: []
        }
    },
    components: {
        Redactor,
        DropdownStore,
        HotVar,
        Checkbox
    },
    created() {
        this.validate()
        this.getDomains()
    },
    methods: {
        addItem(arr: Array<any>, item: any) {
            this.validate()
            if (!Array.isArray(arr)) {
                arr = []
            }
            arr.push(item)
        },
        deleteItem(arr: Array<any>, index: number) {
            // let index = arr.indexOf(item, 0)
            if (index > -1) {
                arr.splice(index, 1)
            }
        },
        getDomains() {
            settingsService.getDomains((domains: any) => {
                this.domains = domains
            })
        },
        validate() {
            if (!Array.isArray(this.settings.mail_to)) {
                this.settings.mail_to = []
            }
            if (!Array.isArray(this.settings.sms_to)) {
                this.settings.sms_to = []
            }
        }
    }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/webpack/vue/settings/components/notification/Notification.vue